<template>
  <div class="slider-box">
    <!-- <agile class="slider" :nav-buttons="false" :dots="false" :autoplay-speed="5000" :speed="2500" fade pause-on-hover autoplay>
        <div class="slide">
          <img src="@/assets/home/image_1.jpg">
        </div>
        <div class="slide">
          <img src="@/assets/home/image_1.jpg">
        </div>
        <div class="slide">
          <img src="@/assets/home/image_1.jpg">
        </div>
    </agile> -->
    <img src="@/assets/home/image_1.jpg">
  </div>
</template>

<script>
// import { VueAgile } from 'vue-agile'

export default {
  name: 'ImageSlider',
  components: {
    // agile: VueAgile 
  }
}
</script>

<style lang="scss" scoped>
.slider-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 100%;
  height: 100%;
}

// .slider {
//   width: 100%;
//   height: 100%;
//   display: flex;
//   align-items: center;

//   .slide {
//     width: 100%;
//     height: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     margin: 0;
//     padding: 0;

//     img {
//       width: 110%;
//       height: 100%;
//     }
//   }
// }
</style>